import { Route, Switch } from "wouter";
import "./index.css";
import { BrowserPage } from "./pages/BrowserPage.tsx";
import { EditorPage } from "./pages/EditorPage.tsx";

// Import commands to register them
import "./editor/commands/index.ts";

export function App() {
  return (
    <Switch>
      <Route path="/">
        <BrowserPage />
      </Route>
      <Route path="/doc/:id">
        {(params) => <EditorPage documentId={params.id} />}
      </Route>
      <Route>
        <BrowserPage />
      </Route>
    </Switch>
  );
}

export default App;
